import "core-js/modules/es.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React from 'react';
import { compose } from 'recompose';
import SvgIcon from 'wfui-digital-core/es/SvgIcon';
import accessibleIcon from 'wfui-digital-core/es/accessibleIcon';

var ChevronIcon = function ChevronIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    viewBox: "0 0 16 16"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5,2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3B3331",
    d: "\n          M6.863,6.537C6.865,6.53 6.867,6.524 6.869,6.518C6.903,6.456 6.931,6.392 6.953,6.326C6.958,6.311 6.958,6.296\n          6.963,6.281C6.977,6.224 6.991,6.167 6.997,6.109C7.002,6.073 6.998,6.037 7,6C6.998,5.963 7.002,5.928 6.998,5.891C6.992,5.833\n          6.978,5.775 6.962,5.719C6.959,5.704 6.958,5.688 6.952,5.674C6.931,5.608 6.903,5.544 6.868,5.48C6.866,5.475 6.864,5.469\n          6.863,5.464C6.825,5.398 6.78,5.335 6.728,5.274C6.728,5.273 6.727,5.272 6.727,5.272C6.717,5.26 6.712,5.249\n          6.703,5.239L2.28,0.421C1.822,-0.078 1.007,-0.143 0.462,0.276C-0.085,0.694 -0.155,1.438 0.303,1.937L4.033,6L0.303,10.063C-0.157,10.562\n          -0.084,11.306 0.462,11.725C1.007,12.142 1.822,12.078 2.281,11.58L6.704,6.76C6.713,6.75 6.718,6.74 6.726,6.729C6.727,6.727\n          6.728,6.725 6.73,6.723C6.781,6.663 6.826,6.601 6.863,6.537Z\n        "
  })));
};

ChevronIcon.defaultProps = {
  width: '16px',
  height: '16px'
};
export default /*#__PURE__*/React.memo(compose(accessibleIcon)(ChevronIcon));